import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "local-main-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListView = _resolveComponent("ListView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ListView, {
      ref: "list-view",
      "complex-list": _ctx.mainData,
      option: _ctx.listOption
    }, null, 8, ["complex-list", "option"])
  ]))
}